import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Component from "components/Component";
import DefaultLoader from "components/common/DefaultLoader";
import React from "react";
import { connect } from "react-redux";
import * as actions from "store/actions/input/program/programActions";
import { useModels } from "store/hooks/modelHooks";

const NO_SELECTION_KEY = "__NO_SELECTION__";

export const ModelSelectorComponent = (props) => {
  const { models, isLoading } = useModels();
  // A saved model that has since left the list still needs an option, or the
  // Select would show nothing and warn about an out-of-range value.
  const options =
    props.model != null && !models.some((model) => model.key === props.model)
      ? [...models, { key: props.model, name: props.model }]
      : models;
  return (
    <Component
      title={"Model"}
      subtitle={"The Model that is to be used for pricing this risk."}
    >
      {isLoading ? (
        <DefaultLoader
          style={{
            width: "100%",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          size={60}
        />
      ) : (
        <FormControl variant={"filled"} fullWidth>
          <InputLabel className={"input-label"}>{"Model"}</InputLabel>
          <Select
            id={"model-selector"}
            value={props.model ?? NO_SELECTION_KEY}
            onChange={(event) => {
              const value =
                event.target.value === NO_SELECTION_KEY
                  ? null
                  : event.target.value;
              props.updateModel(value);
            }}
            inputProps={{
              name: "program-inputs-model",
              id: "program-inputs-model",
            }}
            name={"model"}
            className={"program-inputs-model"}
          >
            {options.map((model) => {
              return (
                <MenuItem key={`Model_${model.key}`} value={model.key}>
                  {model.name}
                </MenuItem>
              );
            })}
            <MenuItem key={"Model_NULL"} value={NO_SELECTION_KEY} />
          </Select>
        </FormControl>
      )}
    </Component>
  );
};

const mapDispatchToProps = {
  updateModel: actions.updateModel,
};

const mapStateToProps = (state) => ({
  model: state?.input?.program?.model ?? null,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelSelectorComponent);
